import React from "react";
import COLORS from "../resources/colors/COLORS";
import ClassStudentFeeSummary from "./ClassStudentFeeSummary";

const TotalDue = () => (
  <ClassStudentFeeSummary
    title="Total Due"
    metricKey="total_due"
    metricLabel="Total Due"
    accentColor={COLORS.card_red || "#ef4444"}
    showOnlyPositive
    showCurrentDueChip
  />
);

export default TotalDue;
